'use client';

import {
	Box, Text, useSlotRecipe,
} from '@chakra-ui/react';

import { NextLinkWrapper } from '@/modules/navigation/presentation';
import { NextImageWrapper } from '@/modules/shared/presentation';
import type { Image } from '@/modules/shared/types';

type SpecialFeatureCardProps = {
	image: Image
	title: string
};

export const SpecialFeatureCard = ({ image, title }: SpecialFeatureCardProps) => {
	const recipe = useSlotRecipe({ key: 'specialFeatureCard' });
	const styles = recipe();

	return (
		<NextLinkWrapper asChild css={styles.root} href="/">
			<NextImageWrapper aspectRatio="wide" css={styles.image} image={image} sizes="300px">
				<Box css={styles.overlay} />
				<Text css={styles.title}>
					{title}
				</Text>
			</NextImageWrapper>
		</NextLinkWrapper>
	);
};
